function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { parseToRgb } from 'polished';
import { useMemo } from 'react';
export default function useAccentColors() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return useMemo(function() {
        var style = {};
        for(var ix = 0; ix < args.length; ix += 1){
            try {
                var _args_ix = _sliced_to_array(args[ix], 2), name = _args_ix[0], color = _args_ix[1];
                if (color === null || color === void 0 ? void 0 : color.startsWith("--")) {
                    style["--".concat(name)] = "var(".concat(color, ")");
                    style["--".concat(name, "-rgb")] = "var(".concat(color, "-rgb)");
                } else {
                    var rgba = color ? parseToRgb(color) : null;
                    if (rgba && color) {
                        style["--".concat(name)] = color;
                        style["--".concat(name, "-rgb")] = "".concat(rgba.red, ",").concat(rgba.green, ",").concat(rgba.blue);
                    }
                }
            } catch (err) {
                console.warn(err);
            }
        }
        return style;
    }, [
        args
    ]);
}

//# sourceMappingURL=useAccentColors.js.map